import PassReset from './PassReset';

export default PassReset;
